import { useLocation, Link } from "react-router-dom";
import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="min-h-screen bg-background-50 flex flex-col">
      <Header />
      <main className="flex-1 flex flex-col items-center justify-center text-center px-4 py-16 md:py-24">
        <span className="font-heading text-7xl md:text-8xl font-bold text-primary-500 select-none">
          404
        </span>
        <h1 className="mt-6 text-xl md:text-2xl font-semibold text-foreground-950">
          This page has not been generated
        </h1>
        <p className="mt-2 text-sm md:text-base text-foreground-500">
          {location.pathname}
        </p>
        <p className="mt-4 text-sm md:text-base text-foreground-600">
          Tell me more about this page, so I can generate it
        </p>
        <Link
          to="/"
          className="mt-8 inline-flex items-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-colors whitespace-nowrap"
        >
          <i className="ri-arrow-left-line"></i>
          Back to Home
        </Link>
      </main>
      <Footer />
    </div>
  );
}